const Errors = {
  SERVER_UNAVAILABLE:
    "Ocurrió un error en la petición, por favor intenta nuevamente.",
};

const IdentifierType = {
  DNI: {key: 1, label: 'D.N.I.'},
  RUC: {key: 6, label: 'R.U.C.'},
  CE: {key: 4, label: 'C.E.'},
  PASSPORT: {key: 7, label: 'Pasaporte'}
}

const ReportTypeValues = {
  COMPLAINT: { key: 1, label: "QUEJA" },
  CLAIM: { key: 2, label: "RECLAMO" },
};

const IsUnderage = {
  NOT: { key: 0, label: "NO" },
  YES: { key: 1, label: "SI" },
};

const ConfigLogoDimensions = {
  width: 272,
  height: 90,
};

const BrandsStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green" },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow" },
};

const UsersStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
};

const ProfileTypes = {
  ADMIN: { key: "ADMINISTRATOR", label: "ADMINISTRADOR" },
  SUPERVISOR: { key: "SUPERVISOR", label: "SUPERVISOR" },
  SUPER_ADMINISTRATOR: { key: "SUPER_ADMINISTRATOR", label: "SUPER ADMINISTRADOR" },
  AFFILIATE: { key: "AFFILIATE", label: "AFILIADO" },
};

const VehicleStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
};

const VehicleTypes = {
  SEDAN: { key: 1, label: "SEDÁN" },
  MINI_BUS: { key: 2, label: "MINI BUS" },
  SUV: { key: 3, label: "SUV" },
  VAN: { key: 4, label: "VAN" },
};

const VehicleProperty = {
  TRAVELCAB: { key: 1, label: "TRAVELCAB" },
  EXTERNAL: { key: 2, label: "EXTERNO" },
};

const VehicleBrands = [
  { key: "BAIC", label: "BAIC" },
  { key: "CHANGAN", label: "CHANGAN" },
  { key: "CHERY", label: "CHERY" },
  { key: "CHEVROLET", label: "CHEVROLET" },
  { key: "DFSK", label: "DFSK" },
  { key: "DONGFENG", label: "DONGFENG" },
  { key: "FIAT", label: "FIAT" },
  { key: "GEELY", label: "GEELY" },
  { key: "GREAT WALL MOTORS (GWM)", label: "GREAT WALL MOTORS (GWM)" },
  { key: "HYUNDAI", label: "HYUNDAI" },
  { key: "JAC", label: "JAC" },
  { key: "JETOUR", label: "JETOUR" },
  { key: "KIA", label: "KIA" },
  { key: "MAZDA", label: "MAZDA" },
  { key: "MG", label: "MG" },
  { key: "NISSAN", label: "NISSAN" },
  { key: "RENAULT", label: "RENAULT" },
  { key: "SUZUKI", label: "SUZUKI" },
  { key: "TOYOTA", label: "TOYOTA" },
  { key: "VOLKSWAGEN", label: "VOLKSWAGEN" },
]

const DriverStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const LicenseTypesPeru = {
  A_I: { key: 1, label: "A-I" }, // vehículos particulares: sedán, SUV, pickup, furgón… :contentReference[oaicite:1]{index=1}
  A_IIA: { key: 2, label: "A-IIa" }, // taxis, ambulancias, transporte público interprovincial, además de A-I :contentReference[oaicite:2]{index=2}
  A_IIB: { key: 3, label: "A-IIb" }, // microbús hasta 16 asientos (4t), minibús hasta 33 asientos (7t), suma A-I y A-IIa :contentReference[oaicite:3]{index=3}
  A_IIIA: { key: 4, label: "A-IIIa" }, // ómnibus urbanos, interurbanos, panorámicos, articulados; incluye A‑I, IIa, IIb :contentReference[oaicite:4]{index=4}
  A_IIIB: { key: 5, label: "A-IIIb" }, // camiones, volquetes, grúas, chasis cabinado, plataforma, etc.; incluye A-I, IIa, IIb :contentReference[oaicite:5]{index=5}
  A_IIIC: { key: 6, label: "A-IIIc" }, // categoría más completa: permite todas las anteriores :contentReference[oaicite:6]{index=6}

  B_I: { key: 7, label: "B-I" }, // triciclos no motorizados para transporte público de pasajeros :contentReference[oaicite:7]{index=7}
  B_IIA: { key: 8, label: "B-IIa" }, // bicimotos para pasajeros o carga :contentReference[oaicite:8]{index=8}
  B_IIB: { key: 9, label: "B-IIb" }, // motocicletas (2 ruedas) y sidecars; incluye B‑IIa :contentReference[oaicite:9]{index=9}
  B_IIC: { key: 10, label: "B-IIc" }, // mototaxis, trimotos; incluye B‑IIa y B‑IIb :contentReference[oaicite:10]{index=10}
};

const BlackListStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' }
}

const AuditLogAction = {
  CREATE: { key: "CREATE", label: "CREAR", color: "badge-gray" },
  UPDATE: { key: "UPDATE", label: "ACTUALIZAR", color: "badge-yellow" },
  DELETE: { key: "DELETE", label: "ELIMINAR", color: "badge-red" },
  LOGIN: { key: "LOGIN", label: "INICIO DE SESIÓN", color: "badge-green" },
}
const CommissionOptions = {
  PERCENTAGE: {
    key: 2,
    label: "Porcentaje"
  },
  FIXED_AMOUNT: {
    key: 1,
    label: "Monto Fijo"
  }
};

const AffiliateCategories = {
  HOTEL:         { key: 1, label: "Hotel" },
  RESTAURANT:    { key: 2, label: "Restaurante" },
  TRAVEL_AGENCY: { key: 3, label: "Agencia de viaje" },
  COMPANY:       { key: 4, label: "Empresa" },
};

const HotelTypes = {
  BOUTIQUE: { key: 1, label: "Boutique" },
  STANDARD: { key: 2, label: "Estándar" },
  RESORT:   { key: 3, label: "Resort" },
};

const AffiliateStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const PassengerIdentifierType = {
  DNI:      { key: 1, label: 'D.N.I.' },
  CE:       { key: 4, label: 'C.E.' },
  PASSPORT: { key: 7, label: 'Pasaporte' },
};

const PassengerType = {
  OCASIONAL:   { key: 1, label: "Ocasional" },
  REGULAR:     { key: 2, label: "Regular" },
  QORE:        { key: 3, label: "QORE" },
  FF:          { key: 4, label: "FF" },
  CORPORATIVO: { key: 5, label: "Corporativo" },
};

const PassengerStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const VehicleTypeStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const CouponStatus = {
  ACTIVE: { key: true, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: false, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const DiscountTypeOptions = [
  { key: 'percent', label: 'Porcentaje (%)' },
  { key: 'fixed', label: 'Monto fijo' },
]

// DEPRECATED: Fuentes ahora son dinámicas desde GET /api/v1/booking-sources
const RideFuente = {
  ELIFE:        { key: "ELIFE",        label: "ELIFE" },
  VIATOR:       { key: "VIATOR",       label: "VIATOR" },
  FF:           { key: "FF",           label: "FF" },
  POLITTAN:     { key: "POLITTAN",     label: "POLITTAN" },
  COSTA_DEL_SOL:{ key: "COSTA DEL SOL",label: "COSTA DEL SOL" },
  MONNET:       { key: "MONNET",       label: "MONNET" },
  DON_ITALO:    { key: "DON ITALO",    label: "DON ITALO" },
  WYNWOOD:      { key: "WYNWOOD",      label: "WYNWOOD" },
}

const RideEstadoPago = {
  PENDIENTE: { key: "Pendiente", label: "Pendiente" },
  PAGADO:    { key: "Pagado",    label: "Pagado" },
  CANCELADO: { key: "Cancelado", label: "Cancelado" },
}

const RideMoneda = {
  SOLES:   { key: "SOLES",   label: "SOLES" },
  DOLARES: { key: "DOLARES", label: "DOLARES" },
}

const RideTipoViaje = {
  APTO_HOT:  { key: "APTO-HOT",  label: "APTO-HOT" },
  HOT_APTO:  { key: "HOT-APTO",  label: "HOT-APTO" },
  DISTRITAL: { key: "DISTRITAL", label: "DISTRITAL" },
}

export default {
  Errors,
  IdentifierType,
  ReportTypeValues,
  IsUnderage,
  ConfigLogoDimensions,
  UsersStatus,
  BrandsStatus,
  ProfileTypes,
  VehicleTypes,
  VehicleProperty,
  LicenseTypesPeru,
  VehicleStatus,
  VehicleBrands,
  DriverStatus,
  CommissionOptions,
  AffiliateCategories,
  HotelTypes,
  AffiliateStatus,
  PassengerIdentifierType,
  PassengerType,
  BlackListStatus,
  AuditLogAction,
  PassengerStatus,
  VehicleTypeStatus,
  CouponStatus,
  DiscountTypeOptions,
  RideFuente,
  RideEstadoPago,
  RideMoneda,
  RideTipoViaje,
};
